<template>
  <Popover
    class="color-picker inline-block"
    placement="right-start"
    :open="isOpen"
    @close="handleClose"
    :modifiers="[
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      },
    ]"
  >
    <div class="color-button" slot="reference">
      <slot v-bind="{handleClick, value}" name="default" />
    </div>

    <div class="min-w-5">
      <p class="m-0 px-4 py-2 text-sm text-gray-700 text">Color</p>
      <Divider />
      <div class="px-2 py-2">
        <ColorPaletteInput
          :value="value"
          @input="$emit('input', arguments[0])"
          @change="$emit('change', arguments[0])"
          :swatches="swatches"
        />
      </div>
    </div>
  </Popover>
</template>

<script>
import ColorPaletteInput from '@converdy/atoms/ColorPaletteInput';
import Surface from '@converdy/atoms/Surface';
import Popover from '@converdy/atoms/Popover';
import Divider from '@converdy/atoms/Divider';

export default {
  name: 'ColorInput',

  components: {
    ColorPaletteInput,
    Surface,
    Divider,
    Popover,
  },

  props: {
    label: {type: String},
    value: {type: String},
    swatches: {type: Array},
  },

  data: () => ({
    isOpen: false,
  }),

  methods: {
    handleClick() {
      console.log('clikkcc from handle click');
      this.isOpen = true;
    },

    handleClose(e) {
      this.isOpen = false;
    },
  },
};
</script>

<style module>
.color-button {
  padding: 0.5rem;
  display: flex;
}

.activator {
  --activator-height: 25px;
  display: inline-block;
  width: 50px;
  height: 30px;
  background: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 2"><path fill="white" d="M1,0H2V1H1V0ZM0,1H1V2H0V1Z"/><path fill="gray" d="M0,0H1V1H0V0ZM1,1H2V2H1V1Z"/></svg>');
  background-size: 6px;
  position: relative;

  @apply border
		border-solid
		border-dull
    rounded;
}

.activatorInner {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>
